import { getAmplitudeInstance } from '../amplitudeHelpers';
import ProductsAvailable from '../enums/ProductsAvailable';
import PurchaseScreenTypePlan from '../enums/PurchaseScreenTypePlan';
import UpsellTrigger from '../enums/UpsellTrigger';

type logUpsellShownParams = {
  products_available?: ProductsAvailable;
  purchase_screen_type_plan?: PurchaseScreenTypePlan;
  remote_image_fetch_requested?: boolean;
  remote_image_fetch_succeeded?: boolean;
  session_had_offline_period?: boolean;
  trail_id?: number;
  trigger?: UpsellTrigger;
};

/**
 * User sees any upsell
 * @param params - Attributes to log with the amplitude event
 * @param params.products_available - The combination of available products offered on an upsell (plus, plus-peak, peak).
 * @param params.purchase_screen_type_plan - The plan shown on the pro purchasing event occurs on (e.g. trial, non-trial, promo, etc.)
 * @param params.remote_image_fetch_requested - TRUE if a remote image fetch was attempted.
 * @param params.remote_image_fetch_succeeded - TRUE if a remote image fetch was displayed.
 * @param params.session_had_offline_period - TRUE if the session went offline at any point before this upsell was shown. Used to audit that post-nav sessions with an offline period are routed to the Offline Maps upsell rather than TBT, and vice versa.
 * @param params.trail_id - The trail id of the associated trail details page where upsell is triggered. Null if trigger is not trail specific.
 * @param params.trigger - Action that triggered the upsell to display
 */
const logUpsellShown = (
  {
    products_available,
    purchase_screen_type_plan,
    remote_image_fetch_requested,
    remote_image_fetch_succeeded,
    session_had_offline_period,
    trail_id,
    trigger
  }: logUpsellShownParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'upsell shown',
    {
      'products available': products_available,
      'purchase screen type plan': purchase_screen_type_plan,
      'remote image fetch requested': remote_image_fetch_requested,
      'remote image fetch succeeded': remote_image_fetch_succeeded,
      'session had offline period': session_had_offline_period,
      'trail id': trail_id,
      trigger
    },
    callback
  );
};

export default logUpsellShown;
